import { inject, Injectable } from '@angular/core';
import { Step } from '../../types';
import { Observable, of, take, tap } from 'rxjs';
import { QuoteStore } from '../../store';
import { QuotePricesService } from '../quote-prices.service';
import { switchMap } from 'rxjs/operators';
import { StepResolverStrategy } from './step-resolver.strategy';
import { BookingStepDefinitionService } from '../step-definition';

@Injectable({
  providedIn: 'root',
})
export class BookingStepResolverService implements StepResolverStrategy {
  private readonly bookingStepDefinitionService = inject(BookingStepDefinitionService);
  private readonly quoteStore = inject(QuoteStore);
  private readonly quotePricesService = inject(QuotePricesService);

  resolve(): Observable<Step> {
    return this.quoteStore.packageDetails$.pipe(
      take(1),
      switchMap((packageDetails) => {
        // If grandTotal is available, use existing package details
        if (packageDetails?.grandTotal) {
          return of({ ...packageDetails });
        }

        // Otherwise fetch quote prices from the service
        return this.quotePricesService.getQuotePrices();
      }),
      tap((quoteState) => {
        this.quoteStore.updateState({ ...quoteState });
      }),
      switchMap(() => of(this.bookingStepDefinitionService.getStepDefinition())),
    );
  }
}
